<template>
  <div class="basicLayout">
    <header>
      <p>{{name}}的财富规划</p>
      <ul>
        <li v-if="getChildrenWhichComp !== 'basicMain'"
            @click="$store.commit('setChildrenWhichComp', 'basicMain');">
          <img src="../../assets/images/wpsp/wpspHome.png"
               class="icon" />财富规划
        </li>
        <li @click="handleDialogClick">
          <img src="../../assets/images/wpsp/财务分析.png"
               class="icon" />财务分析
        </li>
        <li>
          <img src="../../assets/images/wpsp/生涯一览.png"
               class="icon" />生涯一览
        </li>
        <li @click="handleCommand('c')">
          <img src="../../assets/images/wpsp/编组 7.png"
               class="icon" />规划报告
        </li>
        <li>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <img src="../../assets/images/wpsp/生涯规划.png"
                   class="icon" />生涯规划
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a"
                                @mouseover.native="pensionMouseOver"
                                @mouseleave.native="pensionMouseLeave"
                                v-if="custAge<100">
                <img v-if="pension"
                     src="../../assets/images/wpsp/养老-选中.png"
                     style="position: relative;
                  top:5px;
          left:-5px;" />
                <img v-else
                     src="../../assets/images/wpsp/养老.png"
                     style="position: relative;
                  top:5px;
          left:-5px;" />养老规划
              </el-dropdown-item>
              <el-dropdown-item command="b"
                                @mouseover.native="childrenMouseOver"
                                @mouseleave.native="childrenMouseLeave">
                <img v-if="children"
                     src="../../assets/images/wpsp/子女教育-选中.png"
                     style="position: relative;
                  top:5px;
          left:-5px;" />
                <img v-else
                     src="../../assets/images/wpsp/子女教育.png"
                     style="position: relative;
                  top:5px;
          left:-5px;" />子女教育
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </header>
    <!--    监听 store 里面wpspWhichComp属性 加载页面-->
    <component :is="getChildrenWhichComp"></component>
    <el-dialog title="财务分析"
               :visible.sync="dialog.dialogStatus"
               width="70%">
      <div class="dialog-div">
        <ul class="ulList">
          <li @click="handleTabClick('first')"
              :class="[
        {excellentClass: dialog.firstStatus.one,
        goodClass: dialog.firstStatus.two,
        differenceClass: dialog.firstStatus.three},
        dialog.clickIndex==='first'?
        (dialog.firstStatus.one===true?'excellentLineClass':
        (dialog.firstStatus.two===true?'goodLineClass':'differenceLineClass'))
        :''
        ]">
            <p>家庭偿债能力：{{dialog.firstTitle}}</p>
          </li>
          <li @click="handleTabClick('second')"
              :class="[
        {excellentClass: dialog.secondStatus.one,
         goodClass: dialog.secondStatus.two, differenceClass: dialog.secondStatus.three},
          dialog.clickIndex==='second'?
        (dialog.secondStatus.one===true?'excellentLineClass':
        (dialog.secondStatus.two===true?'goodLineClass':'differenceLineClass'))
        :''
        ]">
            <p>家庭应急能力：{{dialog.secondTitle}}</p>
          </li>
          <li @click="handleTabClick('third')"
              :class="[
        {excellentClass: dialog.thirdStatus.one,
        goodClass: dialog.thirdStatus.two,
        differenceClass: dialog.thirdStatus.three},
         dialog.clickIndex==='third'?
        (dialog.thirdStatus.one===true?'excellentLineClass':
        (dialog.thirdStatus.two===true?'goodLineClass':'differenceLineClass'))
        :''
        ]">
            <p>家庭财务自由度：{{dialog.thirdTitle}}</p>
          </li>
          <li ref="Liline">&nbsp;</li>
        </ul>

        <div class="dialog-div-main"
             ref="dialogMain"
             v-show="dialog.clickIndex=='first'">
          <div class="dialogTop">
            <strong>家庭债务偿还能力(%)</strong>
            <div>
              <div class="dialogBottom-left"
                   v-show="solvency.ratioOne.ratio=='-1'">
                <div>
                  <img src="../../assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据，请填写参数</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="solvency.ratioOne.ratio!='-1'">
                <div>
                  <p ref="num">{{solvency.ratioOne.ratio*100>50?
                    '50':(solvency.ratioOne.ratio*100).toFixed(0)}}</p>
                  <img :src="solvency.ratioOne.ratio*100<35?
                  coordinateSrc.green:coordinateSrc.yellow"
                       alt
                       ref="num1" />
                  <div>&nbsp;</div>
                  <ul>
                    <li>0</li>
                    <li>35</li>
                    <li>50</li>
                  </ul>
                </div>
              </div>
              <div class="dialogTop-right">
                <p v-if="solvency.ratioOne.ratio==-1">债务偿还比例，反映的是家庭的债务偿还情况，比如我们房贷，车贷等等是否合理。</p>
                <p v-else-if="solvency.ratioOne.ratio*100>=35">
                  债务偿还比例，反映的是家庭的债务偿还情况，比如我们房贷，车贷等等是否合理。
                  <span>您的家庭债务偿还比例过高</span>，家庭可能随时面临财务危机，需要减少消费，增加家庭收入。
                </p>
                <p v-else>
                  债务偿还比例，反映的是家庭的债务偿还情况，比如我们房贷，车贷等等是否合理。
                  <span>您的家庭债务偿还比小于35%</span>，这表明您可以很好的偿还您的已有债务，并且稍有余地，请继续保持。
                </p>
              </div>
            </div>
          </div>
          <div class="dialogTop"
               style="margin:30px 0px">
            <strong>家庭负债情况(%)</strong>
            <div>
              <div class="dialogBottom-left"
                   v-show="solvency.ratioTwo.ratio=='-1'">
                <div>
                  <img src="../../assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据，请填写参数</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="solvency.ratioTwo.ratio!='-1'">
                <div>
                  <p ref="num10">{{solvency.ratioTwo.ratio*100>100?
                    '100':(solvency.ratioTwo.ratio*100).toFixed(0)}}</p>
                  <img :src="solvency.ratioTwo.ratio*100<50?
                  coordinateSrc.green:coordinateSrc.yellow"
                       alt
                       ref="num11" />
                  <div class="labilities-one">&nbsp;</div>
                  <ul class="labilities-two">
                    <li>0</li>
                    <li>50</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
              <div class="dialogTop-right">
                <p v-if="solvency.ratioTwo.ratio==-1">负债比率是指家庭用于偿还各种债务支出占家庭当月总收入的百分比。</p>
                <p v-else-if="solvency.ratioTwo.ratio*100>50">
                  负债比率是指家庭用于偿还各种债务支出占家庭当月总收入的百分比。
                  <span>您的负债比例过高，超过家庭承受能力</span>
                  ,每月需要付出的利息费将会上升,会在家庭财务发生紧急情况,如失业等情况时,造成财务负担,甚至是“资不抵债”。
                </p>
                <p v-else>
                  负债比率是指家庭用于偿还各种债务支出占家庭当月总收入的百分比。
                  <span>您的负债比例正常，在家庭承受能力范围内</span>,您的家庭债务情况良好，暂时无需为债务担忧。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-div-main"
             ref="dialogMain1"
             v-show="dialog.clickIndex=='second'">
          <div class="dialogTop">
            <strong>家庭资产变现能力</strong>
            <div>
              <div class="dialogBottom-left"
                   v-show="emergency.ratioOne.ratio=='-1'">
                <div>
                  <img src="../../assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据，请填写参数</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="emergency.ratioOne.ratio!='-1'">
                <div>
                  <p ref="num2">{{emergency.ratioOne.ratio>9?'9':emergency.ratioOne.ratio}}</p>
                  <img :src="(emergency.ratioOne.ratio>3&&emergency.ratioOne.ratio<6)?
                  coordinateSrc.green:coordinateSrc.yellow"
                       alt
                       ref="num3" />
                  <div class="assets-one">&nbsp;</div>
                  <ul class="assets-two">
                    <li>0</li>
                    <li>3</li>
                    <li>6</li>
                    <li>9</li>
                  </ul>
                </div>
              </div>
              <div class="dialogTop-right">
                <p v-if="emergency.ratioOne.ratio==-1">流动性比率是指能迅速变现而不会带来损失的资产,
                  比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。</p>
                <p v-else-if="emergency.ratioOne.ratio>6">
                  流动性比率是指能迅速变现而不会带来损失的资产,比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。
                  <span>这意味着您家庭的闲置资金较多，不利于资产的保值增值。</span>
                </p>
                <p v-else-if="emergency.ratioOne.ratio>=3&&emergency.ratioOne.ratio<=6">
                  流动性比率是指能迅速变现而不会带来损失的资产,比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。
                  <span>这意味着您家庭的闲置资金处于正常水平，您可以继续保持。</span>
                </p>
                <p v-else>
                  流动性比率是指能迅速变现而不会带来损失的资产,比如现金、活期存款、货币基金等,该比例用来权衡你的家庭财务状态以及变现能力。
                  <span>这意味着家庭可能存在财务危机，</span>一旦家庭成员遇到病重住院等突发事情，不能及时拿出钱应对，家庭抗风险能力较低。
                </p>
              </div>
            </div>
          </div>

          <div class="dialogTop"
               style="margin:30px 0px">
            <strong>家庭储蓄能力(%)</strong>
            <div>
              <div class="dialogBottom-left"
                   v-show="emergency.ratioTwo.ratio=='-1'">
                <div>
                  <img src="../../assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据，请填写参数</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="emergency.ratioTwo.ratio!='-1'">
                <div>
                  <p ref="num4">{{emergency.ratioTwo.ratio*100>100?
                    '100':(emergency.ratioTwo.ratio*100).toFixed(0)}}</p>
                  <img :src="(emergency.ratioTwo.ratio*100>40&&emergency.ratioTwo.ratio*100<60)?
                  coordinateSrc.green:coordinateSrc.yellow"
                       alt
                       ref="bum5" />
                  <div class="savings-one">&nbsp;</div>
                  <ul class="savings-two">
                    <li>0</li>
                    <li>40</li>
                    <li>60</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
              <div class="dialogTop-right">
                <p v-if="emergency.ratioTwo.ratio==-1">储蓄率，是家庭可支配收入中储蓄的占比，
                  反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。</p>
                <p v-else-if="emergency.ratioTwo.ratio*100<40">
                  储蓄率，是家庭可支配收入中储蓄的占比，反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭储蓄率低于40%，</span>这说明家庭的开支较多，没能进行很好的储蓄积累。建议对家庭资产开支进行有效规划，做好储蓄和花费之间的平衡。
                </p>
                <p v-else-if="emergency.ratioTwo.ratio*100>=40&&emergency.ratioTwo.ratio*100<=60">
                  储蓄率，是家庭可支配收入中储蓄的占比，反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率处于正常水平，请继续保持</span>
                </p>
                <p v-else>
                  储蓄率，是家庭可支配收入中储蓄的占比，反映的是家庭的储蓄情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭储蓄率超过60%，</span>
                  通过储蓄虽然可以积累财富，但进行合理的消费可以显著的提高生活水平，建议对家庭开支进行有效规划，做好储蓄和花费之间的平衡。
                </p>
              </div>
            </div>
          </div>
          <div class="dialogTop"
               style="margin:30px 0px">
            <strong>家庭消费能力(%)</strong>
            <div>
              <div class="dialogBottom-left"
                   v-show="emergency.ratioThree.ratio=='-1'">
                <div>
                  <img src="../../assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据，请填写参数</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="emergency.ratioThree.ratio!='-1'">
                <div>
                  <p ref="num6">{{emergency.ratioThree.ratio*100>100?
                    '100':(emergency.ratioThree.ratio*100).toFixed(0)}}</p>
                  <img :src="(emergency.ratioThree.ratio*100>40&&emergency.ratioThree.ratio*100<60)?
                  coordinateSrc.green:coordinateSrc.yellow"
                       alt
                       ref="num7" />
                  <div class="savings-one">&nbsp;</div>
                  <ul class="savings-two">
                    <li>0</li>
                    <li>40</li>
                    <li>60</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
              <div class="dialogTop-right">
                <p v-if="emergency.ratioThree.ratio==-1">消费比例，是家庭消费支出/家庭收入，
                  反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。</p>
                <p v-else-if="emergency.ratioThree.ratio*100<40">
                  消费比例，是家庭消费支出/家庭收入，反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率低于40%，</span>
                  这说明家庭的开支较少，虽能存下很多钱，但是之后家庭的生活质量和品质被降低了。
                  消费比例一定要合理，过低、过高都会影响到我们的生活。
                </p>
                <p v-else-if="emergency.ratioThree.ratio*100>=40
                  &&emergency.ratioThree.ratio*100<=60">
                  消费比例，是家庭消费支出/家庭收入，反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率处于正常水平，请继续保持。</span>
                </p>
                <p v-else>
                  消费比例，是家庭消费支出/家庭收入，反映的是家庭的收支情况，此比例一般在40%-60%之间比较合理。
                  <span>您的家庭消费比率超过60%，</span>这说明家庭的储蓄能力不强，不利于家庭积累更多的财富。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-div-main"
             ref="dialogMain2"
             v-show="dialog.clickIndex=='third'">
          <div class="dialogTop">
            <strong>家庭财务自由度(%)</strong>
            <div>
              <div class="dialogBottom-left"
                   v-show="finance.ratioOne.ratio=='-1'">
                <div>
                  <img src="../../assets/images/wpsp/text.png"
                       alt />
                  <span>暂无计算数据，请填写参数</span>
                </div>
              </div>
              <div class="dialogTop-left"
                   v-show="finance.ratioOne.ratio!='-1'">
                <div>
                  <p ref="num8">{{finance.ratioOne.ratio*100>100?
                    '100':(finance.ratioOne.ratio*100).toFixed(0)}}</p>
                  <img :src="custAge<30?finance.ratioOne.ratio*100>
                    5&&finance.ratioOne.ratio*100
                    <15?coordinateSrc.green:coordinateSrc.yellow:custAge<40?
                    finance.ratioOne.ratio*100
                    >15&&finance.ratioOne.ratio*100
                    <30?coordinateSrc.green:coordinateSrc.yellow:custAge<50?
                    finance.ratioOne.ratio*100
                    >30&&finance.ratioOne.ratio*100<50?coordinateSrc.green:coordinateSrc.yellow:
                    finance.ratioOne.ratio*100
                    >50?coordinateSrc.green:coordinateSrc.yellow"
                       alt
                       ref="num9" />
                  <div :class="custAge<30?'finance-one-1':custAge<40
                    ?'finance-one-2':custAge<50?'finance-one-3':'finance-one-4'">&nbsp;</div>
                  <ul class="finance-two">
                    <li>0</li>
                    <li>5</li>
                    <li>15</li>
                    <li>30</li>
                    <li>50</li>
                    <li>100</li>
                  </ul>
                </div>
              </div>
              <div class="dialogTop-right">
                <p v-if="finance.ratioOne.ratio==-1">财务自由度是指，当您不工作的时候，
                  也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。</p>
                <p v-else-if="custAge<30&&finance.ratioOne.ratio*100>15">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。

                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。您已经实现了财务自由，
                  </span>当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="custAge<30&&finance.ratioOne.ratio*100
                  <=15&&finance.ratioOne.ratio*100>=5">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。
                </p>
                <p v-else-if="custAge<30&&finance.ratioOne.ratio*100<5">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>

                <p v-else-if="custAge>=30&&custAge<40&&finance.ratioOne.ratio*100>30">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。您已经实现了财务自由，</span>
                  当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="custAge>=30&&custAge<40&&finance.ratioOne.ratio*100
                  <=30&&finance.ratioOne.ratio*100>=15">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。
                </p>
                <p v-else-if="custAge>=30&&custAge<40&&finance.ratioOne.ratio*100<15">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>
                <p v-else-if="custAge>=40&&custAge<50&&finance.ratioOne.ratio*100>50">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。

                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。您已经实现了财务自由，</span>
                  当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="custAge>=40&&custAge<50&&finance.ratioOne.ratio*100
                  <=50&&finance.ratioOne.ratio*100>=30">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。

                </p>
                <p v-else-if="custAge>=40&&custAge
                <50&&finance.ratioOne.ratio*100<30">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>

                <p v-else-if="custAge>=50&&finance.ratioOne.ratio*100>=100">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。您已经实现了财务自由，</span>
                  当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销
                </p>
                <p v-else-if="custAge>=50&&finance.ratioOne.ratio*100
                  <100&&finance.ratioOne.ratio*100>=50">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较高，</span>
                  但是，离财务自由（财务自由度100%）还有一定距离。

                </p>
                <p v-else-if="custAge>=50&&finance.ratioOne.ratio*100<50">
                  财务自由度是指，当您不工作的时候，也不必为金钱发愁，因为您其他投资的收益已经能够支撑起您家庭的开销。
                  <span>通过计算，您的家庭财务自由度为
                    {{(finance.ratioOne.ratio*100).toFixed(0)}}%。财务自由度较低，</span>
                  您需要进一步拓宽投资渠道，调整投资结构，增加如债券、基金等生息资产的投资比例，以提高投资收益
                </p>
              </div>
            </div>
          </div>
          <div class="dialogBottom"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import basicMain from '@/pages/wpsp/base-information/basicMain.vue';
import childrenEducationHome from '@/pages/wpsp/children-education/children-educationHome.vue';
import pensionPlanningHome from '@/pages/wpsp/pension-planning/pension-planningHome.vue';
import PresentationList from '@/pages/wpsp/PlanningReport/PresentationList.vue';
import greenCoordinate from '../../assets/images/wpsp/greenCoordinate.png';
import yellowCoordinate from '../../assets/images/wpsp/yellowCoordinate.png';

export default {
  components: {
    basicMain, childrenEducationHome, pensionPlanningHome, PresentationList,
  },

  name: 'basicLayout',
  data() {
    return {
      name: '',
      custAge: '', // 客户年龄
      cis: '',
      a: '良',
      b: '优',
      // 弹窗集合
      dialog: {
        dialogStatus: false,
        activeName: 'first',
        firstTitle: '良',
        // 如果name 等于first 说明tab点击第一个
        clickIndex: 'first',
        // one是优，two是良，three是差
        firstStatus: {
          one: false,
          two: true,
          three: false,
        },
        secondTitle: '优',
        secondStatus: {
          one: true,
          two: false,
          three: false,
        },
        thirdTitle: '差',
        thirdStatus: {
          one: false,
          two: false,
          three: true,
        },
      },
      coordinateSrc: {
        green: greenCoordinate,
        yellow: yellowCoordinate,
      },
      // 家庭偿债能力
      solvency: { ratioOne: { ratio: '-1' }, ratioTwo: { ratio: '-1' } },
      // 家庭应急能力
      emergency: {
        ratioOne: { ratio: '-1' },
        ratioTwo: { ratio: '-1' },
        ratioThree: { ratio: '-1' },
      },
      // 家庭财务自由
      finance: { ratioOne: { ratio: '-1' } },
      // 养老规划是否选中
      pension: false,
      // 子女教育是否选中
      children: false,
    };
  },
  computed: {
    ...mapGetters(['getChildrenWhichComp']),
  },
  created() {
    this.cis = this.$route.query.cis;
    sessionStorage.setItem('curCis', JSON.parse(sessionStorage.getItem('cis')));
    const a = Math.random();
    sessionStorage.setItem('userInfo', JSON.stringify({ num: a }));
    this.$store.commit('setChildrenWhichComp', 'basicMain');
    console.log(sessionStorage.getItem('userInfo'), 'sssssssssss');
  },
  mounted() {
    this.$nextTick(() => {
      console.log(22222, this.$refs);
    });
    console.log(41);
  },
  watch: {
    '$store.state.wpspUserInfo': {
      immediate: true,
      deep: true,
      handler() {
        this.name = this.$store.state.wpspUserInfo.custName;
        this.custAge = JSON.parse(sessionStorage.getItem('custInfo')).custAge;
      },
    },
  },
  methods: {
    pensionMouseOver() {
      this.pension = true;
    },
    pensionMouseLeave() {
      this.pension = false;
    },
    childrenMouseOver() {
      this.children = true;
    },
    childrenMouseLeave() {
      this.children = false;
    },
    handleCommand(command) {
      console.log(command);
      let data = '';
      switch (command) {
        case 'a':
          data = 'pensionPlanningHome';
          sessionStorage.setItem('flagFrom', 0);
          break;
        case 'b':
          data = 'childrenEducationHome';
          break;
        case 'c':
          data = 'PresentationList';
          break;
        default:
          data = 'basicMain';
      }
      console.log(data);
      this.$store.commit('setChildrenWhichComp', data);
    },
    // 财务分析
    handleTabClick(index) {
      this.dialog.clickIndex = index;
      if (index === 'first') {
        this.$refs.Liline.style.left = '1px';
        if (this.dialog.firstStatus.one === true) {
          // 改变tab下边框颜色
          this.$refs.Liline.style.backgroundColor = '#CCF1E2';
          // 内容边框颜色
          this.$refs.dialogMain.style.border = '1px solid #02BB6F';
        } else if (this.dialog.firstStatus.two === true) {
          this.$refs.Liline.style.backgroundColor = '#FEEDD2';
          this.$refs.dialogMain.style.border = '1px solid #FAA61C';
        } else {
          this.$refs.Liline.style.backgroundColor = '#FEDDDD';
          this.$refs.dialogMain.style.border = '1px solid #F95353';
        }
      } else if (index === 'second') {
        // 计算家庭应急能力线段轴的偏移量
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num2.style.left = this.emergency.ratioOne.ratio < 9
          ? this.emergency.ratioOne.ratio === 0
            ? '-2%'
            : `${(this.emergency.ratioOne.ratio / 9) * 100 - 2}%`
          : '98%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num3.style.left = this.emergency.ratioOne.ratio < 9
          ? this.emergency.ratioOne.ratio === 0
            ? '-3.5%'
            : `${(this.emergency.ratioOne.ratio / 9) * 100 - 3.5}%`
          : '96.5%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num4.style.left = this.emergency.ratioTwo.ratio * 100 < 100
          ? this.emergency.ratioTwo.ratio === 0
            ? '-2%'
            : `${this.emergency.ratioTwo.ratio * 100 - 2}%`
          : '98%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.bum5.style.left = this.emergency.ratioTwo.ratio * 100 < 100
          ? this.emergency.ratioTwo.ratio === 0
            ? '-3.5%'
            : `${this.emergency.ratioTwo.ratio * 100 - 3.5}%`
          : '96.5%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num6.style.left = this.emergency.ratioThree.ratio * 100 < 100
          ? this.emergency.ratioThree.ratio === 0
            ? '-2%'
            : `${this.emergency.ratioThree.ratio * 100 - 2}%`
          : '98%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num7.style.left = this.emergency.ratioThree.ratio * 100 < 100
          ? this.emergency.ratioThree.ratio === 0
            ? '-3.5%'
            : `${this.emergency.ratioThree.ratio * 100 - 3.5}%`
          : '96.5%';
        this.$refs.Liline.style.left = '201px';
        if (this.dialog.secondStatus.one === true) {
          this.$refs.Liline.style.backgroundColor = '#CCF1E2';
          this.$refs.dialogMain1.style.border = '1px solid #02BB6F';
        } else if (this.dialog.secondStatus.two === true) {
          this.$refs.Liline.style.backgroundColor = '#FEEDD2';
          this.$refs.dialogMain1.style.border = '1px solid #FAA61C';
        } else {
          this.$refs.Liline.style.backgroundColor = '#FEDDDD';
          this.$refs.dialogMain1.style.border = '1px solid #F95353';
        }
      } else if (index === 'third') {
        // 财务自由度线段轴偏移量
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num8.style.left = this.finance.ratioOne.ratio * 100 < 100
          ? this.finance.ratioOne.ratio === 0
            ? '-2%'
            : `${this.finance.ratioOne.ratio * 100 - 2}%`
          : '98%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num9.style.left = this.finance.ratioOne.ratio * 100 < 100
          ? this.finance.ratioOne.ratio === 0
            ? '-3.5%'
            : `${this.finance.ratioOne.ratio * 100 - 4}%`
          : '96.5%';
        this.$refs.Liline.style.left = '401px';
        if (this.dialog.thirdStatus.one === true) {
          this.$refs.Liline.style.backgroundColor = '#CCF1E2';
          this.$refs.dialogMain2.style.border = '1px solid #02BB6F';
        } else if (this.dialog.thirdStatus.two === true) {
          this.$refs.Liline.style.backgroundColor = '#FEEDD2';
          this.$refs.dialogMain2.style.border = '1px solid #FAA61C';
        } else {
          this.$refs.Liline.style.backgroundColor = '#FEDDDD';
          this.$refs.dialogMain2.style.border = '1px solid #F95353';
        }
      }
    },
    // 根据tab优良差状态改变tan颜色
    colorChange(tab1, tab2, tab3) {
      this.dialog.firstTitle = tab1;
      if (this.dialog.firstTitle === '优') {
        this.dialog.firstStatus = {
          one: true,
          two: false,
          three: false,
        };
      } else if (this.dialog.firstTitle === '良') {
        this.dialog.firstStatus = {
          one: false,
          two: true,
          three: false,
        };
      } else {
        this.dialog.firstStatus = {
          one: false,
          two: false,
          three: true,
        };
      }
      this.dialog.secondTitle = tab2;
      if (this.dialog.secondTitle === '优') {
        this.dialog.secondStatus = {
          one: true,
          two: false,
          three: false,
        };
      } else if (this.dialog.secondTitle === '良') {
        this.dialog.secondStatus = {
          one: false,
          two: true,
          three: false,
        };
      } else {
        this.dialog.secondStatus = {
          one: false,
          two: false,
          three: true,
        };
      }
      this.dialog.thirdTitle = tab3;
      if (this.dialog.thirdTitle === '优') {
        this.dialog.thirdStatus = {
          one: true,
          two: false,
          three: false,
        };
      } else if (this.dialog.thirdTitle === '良') {
        this.dialog.thirdStatus = {
          one: false,
          two: true,
          three: false,
        };
      } else {
        this.dialog.thirdStatus = {
          one: false,
          two: false,
          three: true,
        };
      }
    },
    // 请求数据
    requestData() {
      const parames2 = {
        sendInsCode: 'mock', // 类型：String  必有字段  备注：发送机构代码
        receiveInsCode: 'mock', // 类型：String  必有字段  备注：接受结构代码
        sendSystemId: 'mock', // 类型：String  必有字段  备注：发送系统编号
        systemToken: 'mock', // 类型：String  必有字段  备注：系统认证token
        userToken: 'mock', // 类型：String  必有字段  备注：用户认证token
        version: 'mock', // 类型：String  必有字段  备注：接口版本
        data: {
          cis: this.cis, // 类型：String  必有字段  备注：客户号
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.financialAnalysis, parames2).then((res) => {
        // eslint-disable-next-line prefer-destructuring
        this.solvency = res.data.list[0];
        // eslint-disable-next-line prefer-destructuring
        this.emergency = res.data.list[1];
        // eslint-disable-next-line prefer-destructuring
        this.finance = res.data.list[2];
        // 偿债能力线段轴偏移量（打开财务分析默认选中第一个tab所以在这里计算）
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num.style.left = this.solvency.ratioOne.ratio * 100 < 50
          ? this.solvency.ratioOne.ratio === 0
            ? '-2%'
            : `${this.solvency.ratioOne.ratio * 100 * 2 - 2}%`
          : '98%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num1.style.left = this.solvency.ratioOne.ratio * 100 < 50
          ? this.solvency.ratioOne.ratio === 0
            ? '-3.5%'
            : `${this.solvency.ratioOne.ratio * 100 * 2 - 4}%`
          : '96.5%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num10.style.left = this.solvency.ratioTwo.ratio * 100 < 100
          ? this.solvency.ratioTwo.ratio === 0
            ? '-2%'
            : `${this.solvency.ratioTwo.ratio * 100 - 2}%`
          : '98%';
        // eslint-disable-next-line no-nested-ternary
        this.$refs.num11.style.left = this.solvency.ratioTwo.ratio * 100 < 100
          ? this.solvency.ratioTwo.ratio === 0
            ? '-3.5%'
            : `${this.solvency.ratioTwo.ratio * 100 - 4}%`
          : '96.5%';
        this.colorChange(
          this.solvency.tabtitle,
          this.emergency.tabtitle,
          this.finance.tabtitle,
        );
        this.handleTabClick('first');
      });
    },
    handleDialogClick() {
      this.custAge = JSON.parse(sessionStorage.getItem('custInfo')).custAge;
      this.dialog.dialogStatus = true;
      this.$nextTick(() => {
        console.log('1', document.getElementsByClassName('el-tabs__item'));
        this.requestData();
      });
    },
  },
};
</script>
<style  lang="scss">
.basicLayout {
  .popper__arrow::after {
    display: none;
  }
}
</style>
<style scoped lang="scss">
.excellentClass {
  background: rgba(2, 187, 111, 0.2);
}
.goodClass {
  background: rgba(250, 166, 28, 0.2);
}
.differenceClass {
  background: rgba(249, 83, 83, 0.2);
}
.excellentLineClass {
  border: 1px solid #02bb6f;
}
.goodLineClass {
  border: 1px solid #faa61c;
}
.differenceLineClass {
  border: 1px solid #f95353;
}
.el-tabs {
  width: 850px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
  font-size: 14px;
  width: 136px;
  height: 40px;
  line-height: 40px;
  display: block;
}
.el-icon-arrow-down {
  font-size: 16px;
}
.el-dropdown-menu {
  // top: 37px !important;
  width: 136px;
  // z-index: 1 !important;
}

.basicLayout {
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    padding: 8px 20px;
    background: #ffffff;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 6px 0 #e5e7eb;
    > p {
      font-size: 16px;
      color: #303133;
    }
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      li {
        cursor: pointer;
        font-size: 14px;
        color: #ffffff;
        margin-right: 8px;
        background: #1e88ff;
        border-radius: 4px;
        width: 136px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        z-index: 10;
        &:last-of-type {
          margin-right: 0;
        }
        .icon {
          position: relative;
          top: 5px;
          left: -5px;
        }
        .drop-down-icon {
          position: relative;
          top: 10px;
          left: -5px;
        }
      }
    }
  }
  .dialogTop {
    strong {
      font-size: 14px;
      color: #303133;
      padding-top: 10px;
      padding-bottom: 20px;
      display: block;
    }
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      .dialogTop-left {
        margin-right: 42px;
        width: calc(50% - 42px);
        > div {
          width: 281px;
          height: 10px;
          border: 1px solid #606266;
          border-top: 0;
          position: relative;
          > p {
            position: absolute;
            width: 35px;
            left: 0;
            bottom: 30px;
            font-size: 14px;
            color: #303133;
            letter-spacing: 0.67px;
          }
          img {
            position: absolute;
            left: 0;
            bottom: 5px;
          }
          > div {
            background: rgba(2, 187, 111, 0.2);
            border: 1px dashed #02bb6f;
            border-bottom: 0;
            width: 193px;
            height: 18px;
            position: absolute;
            left: 0;
            bottom: 0;
          }
          > ul {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: nowrap;
            position: relative;
            li {
              &:nth-child(1) {
                position: absolute;
                left: -5px;
                top: 20px;
              }
              &:nth-child(2) {
                position: absolute;
                left: 66%;
                top: 20px;
              }
              &:nth-child(3) {
                position: absolute;
                right: -10px;
                top: 20px;
              }
            }
          }
        }
        .assets-one {
          width: 33.33%;
          left: 33.33%;
        }
        .assets-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 33%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              left: 66%;
              top: 20px;
            }
            &:nth-child(4) {
              position: absolute;
              right: -5px;
              top: 20px;
            }
          }
        }
        .savings-one {
          width: 20%;
          left: 40%;
        }
        .savings-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 38%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              left: 58%;
              top: 20px;
            }
            &:nth-child(4) {
              position: absolute;
              right: -10px;
              top: 20px;
            }
          }
        }
        .finance-one-1 {
          width: 10%;
          left: 5%;
        }
        .finance-one-2 {
          width: 15%;
          left: 15%;
        }
        .finance-one-3 {
          width: 20%;
          left: 30%;
        }
        .finance-one-4 {
          width: 50%;
          left: 50%;
        }
        .finance-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 3%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              left: 13%;
              top: 20px;
            }
            &:nth-child(4) {
              position: absolute;
              left: 28%;
              top: 20px;
            }
            &:nth-child(5) {
              position: absolute;
              left: 48%;
              top: 20px;
            }
            &:nth-child(6) {
              position: absolute;
              right: -10px;
              top: 20px;
            }
          }
        }
        .labilities-one {
          width: 50%;
          position: absolute;
          left: -1px;
        }
        .labilities-two {
          li {
            &:nth-child(1) {
              position: absolute;
              left: -5px;
              top: 20px;
            }
            &:nth-child(2) {
              position: absolute;
              left: 47%;
              top: 20px;
            }
            &:nth-child(3) {
              position: absolute;
              right: -10px;
              top: 20px;
            }
          }
        }
      }
      .dialogTop-right {
        width: 50%;
        p {
          font-size: 14px;
          color: #606266;
          line-height: 20px;
          span {
            font-size: 14px;
            color: #c70a0ada;
            letter-spacing: -0.1px;
            line-height: 20px;
          }
        }
      }
    }
  }
  .dialogBottom {
    margin-top: 40px;
    strong {
      font-size: 14px;
      color: #303133;
      display: block;
      padding-bottom: 10px;
    }
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      .dialogBottom-left {
        width: calc(50% - 42px);
        background: #f5f7fa;
        margin-right: 42px;
        div {
          width: 291px;
          height: 84px;
          text-align: center;
          line-height: 84px;
          img {
            width: 20px;
            height: 20px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 13px;
          }
          span {
            font-size: 14px;
            color: #c0c4cc;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      .dialogBottom-right {
        width: 50%;
        p {
          font-size: 14px;
          color: #606266;
          line-height: 20px;
        }
      }
    }
  }
  .dialogBottom-left {
    width: calc(50% - 42px);
    background: #f5f7fa;
    margin-right: 42px;
    div {
      width: 291px;
      height: 84px;
      text-align: center;
      line-height: 84px;
      img {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 13px;
      }
      span {
        font-size: 14px;
        color: #c0c4cc;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  .dialog-div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .ulList {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      position: relative;
      cursor: pointer;
      li {
        width: 200px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        &:last-of-type {
          height: 1px;
          position: absolute;
          left: 0;
          bottom: 0;
          background-color: #1e88ff;
          z-index: 999;
        }
        p {
          font-size: 16px;
          color: #303133;
        }
      }
    }
    .dialog-div-main {
      width: 100%;
      padding: 0 35px;
      border: 1px solid red;
      margin-top: -1px;
    }
  }
}
</style>
